import React from 'react';
import {StaticImage} from "gatsby-plugin-image";

function FluorescenceDescription(props) {
    return (
        <div>
            <div className="about-wrapper ptb--120 bg_color--1">
                <div className="container">
                    <div className="row align-items-center text-center text-lg-left">
                        <div className="col-lg-6 col-md-12 col-xl-6 order-0 order-lg-0">
                            <div className="about-inner inner p-2 p-lg-4">
                                <div className="section-title">
                                    <div className="mb-3">
                                        <span className="badge">NOVO</span>
                                        <span className="badge">Vodeni ogledi</span>
                                    </div>
                                    <h2 className="title mb-3">Rudniška fluorescenca v Izvoznem ali Glavnem rovu</h2>
                                    <p className="description">Doživi skrivnostno moč podzemlja na povsem drugačen način! Sprehod v rudniku je vodena izkušnja v rovih, kjer se s pomočjo UV-svetilk podate na čutno in vizualno raziskovanje čudovitih mineralnih struktur in drugih presenečenj pod zemljo.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-xl-6 order-1 mt-4 order-lg-1">
                            <div className="thumbnail">
                                <StaticImage
                                    src="../../assets/images/rudnik/uv-experience-page-1.jpg"
                                    alt="Rudniška fluorescenca v Rudniku Sitarjevec"
                                    placeholder="blurred"
                                    imgClassName="img-fluid w-100"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-wrapper pb--120">
                <div className="container">
                    <div className="row row--35 align-items-center">
                        <div className="col-lg-6 order-1 order-lg-0">
                            <div className="thumbnail">
                                <StaticImage
                                    src="../../assets/images/rudnik/uv-experience-page-2.jpg"
                                    alt="Nataša Harisch - raziskovalka UV doživetij"
                                    placeholder="blurred"
                                    imgClassName="img-fluid w-100"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 order-0 order-lg-1 text-center text-md-left">
                            <div className="about-inner inner">
                                <div className="section-title">
                                    <p className="description">Na UV doživetje vas skupaj z vodnikom popelje Nataša Harisch, farmacevtska tehnologinja in raziskovalka skrivnostnih svetov micelija. Njeno delo združuje znanost, naravo in ustvarjalnost. Iz ljubezni do gozda je nastala Gobja potka, nočna dogodivščina, kjer obiskovalci z UV lučkami odkrivajo skrivnostni svet svetlečih gliv, gozdnih vonjav in mikroskopskih mrež življenja. Projekt, ki povezuje znanost in čarobnost narave, je leta 2025 prejel nagrado na turističnem start-up vikendu.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FluorescenceDescription;
